import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { DisconnectLinkedinModalComponent } from './disconnect-linkedin-modal.component';

@NgModule({
  imports: [CommonModule, TrackingModule, UiModule],
  declarations: [DisconnectLinkedinModalComponent],
})
export class DisconnectLinkedinModalModule {}
